import { ReactNode } from 'react'
import { useDashboardPermissions } from '~/dashboards/hooks'
import { Card, CardBody, Link as ChakraLink, RefreshError } from '~/design_system'
import { SadStates } from '~/components/SadStates'
import { useMsg } from '~/common/localizationUtils'
import { useIsSanaRebrandEnabled } from '~/theme/useIsSanaRebrandEnabled'

type StatCardContainerProps = {
  children: ReactNode
  customReportUrl?: string
  isError: boolean
}

export const StatCardContainer = ({ children, customReportUrl, isError, ...rest }: StatCardContainerProps) => {
  const msg = useMsg()
  const { has_access_to_custom_report_templates: hasAccessToReportTemplates } = useDashboardPermissions() || {}
  const isRebrand = useIsSanaRebrandEnabled()
  const cardBodyPadding = isError ? { paddingLeft: 2, paddingRight: 2, paddingTop: 4 } : { padding: 4 }

  return (
    <ChakraLink
      variant="unstyled"
      target="_blank"
      href={customReportUrl}
      _hover={{ textDecoration: 'none' }}
      isDisabled={isError || !hasAccessToReportTemplates}
      _disabled={{ opacity: 1, cursor: 'not-allowed' }}
      {...rest}>
      <Card _hover={{ background: isError ? '#fff' : 'rgba(0,0,0,0)' }}>
        <CardBody sx={isRebrand ? {} : cardBodyPadding}>
          <SadStates
            states={[
              {
                when: isError,
                render: () => <RefreshError title={msg('common.ui.error_processing_request_try_again')} />
              }
            ]}>
            {children}
          </SadStates>
        </CardBody>
      </Card>
    </ChakraLink>
  )
}
